export const SET_USER_INFO = 'SET_USER_INFO';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
